import axios from 'axios';

class http {

	setToken(val) { this.setCookie('w_access_token', val) }

	getToken()    { return this.getCookie('w_access_token') }

	setCookie(key, val) { document.cookie = key + "=" + val + "; " }

	getCookie(key)
	{
		let name = key + "=";

		let ca = document.cookie.split(';');

		for(var i=0; i<ca.length; i++) 
		{
		  var c = ca[i].trim();
		  if (c.indexOf(name) === 0) 
		  	return c.substring(name.length,c.length);
		}

		return "3345678";
	}

	get(url, query, callback)
	{
		
		const request = axios.create({
			timeout: 300000,
			headers: { 
				"Access-Token": this.getToken()
			},
			withCredentials: false,
		});

		request.get(url, { params: query }).then(response => {
			
			let state = true;

			if (response.status !== 200)
			{
				state = false
			}

			const { code = 204, reason='目前無法取得資料', data={} } = response.data;

			let res = {code:code, reason:reason, data:data}

			if (callback) callback(state, res)
		})
		.catch( error => {
			let data = { code: 500, reason:"發生錯誤", error: error, data:{}};
			
			if (error.response)
			{
				data.code = error.response.status
				data.message = error.response.statusText
			}
			
			if (callback) callback(false, data)
		})
	}

	post(url, data, callback)
	{
		const request = axios.create({
			timeout: 30000000,
			headers: { 
				"Content-Type" : "application/json",
				"Access-Token" : this.getToken()
			},
			withCredentials: false,
		});

		request.post(url, data && JSON.stringify(data)).then(response => {
			
			let state = true;

			if (response.status !== 200)
			{
				state = false
			}

			const { code = 204, reason='目前無法取得資料', data={} } = response.data;

			let res = {code:code, reason:reason, data:data}

			if (callback) callback(state, res)
		})
		.catch( error => {
			let data = { code: 500, reason:"發生錯誤", error: error, data:{}};
			
			if (error.response)
			{
				data.code = error.response.status
				data.message = error.response.statusText
			}
			
			if (callback) callback(false, data)
		})
	}
}
export default new http();


// WEBPACK FOOTER //
// ./src/helpers/http.js